export const configChangeTypes = {
  GET_CONFIG_CHANGE: 'GET_CONFIG_CHANGE',
  SET_CONFIG_CHANGE_FILTERS: 'SET_CONFIG_CHANGE_FILTERS',
  RESTORE_INITIAL: 'RESTORE_INITIAL',
};